import React, { Component } from 'react';
import { withRouter } from 'react-router-dom';
import ReferralBody from '../../components/referral/Referral';
import {Helmet} from "react-helmet";

import './Referral.css';

class Referral extends Component {
	render() {
		return (
			<div id="referral-page">
				<Helmet>
                    <title>Refer Your Friends and Get $20 Off! - HelloAva</title>
                    <meta name="description" content="Want to send beautifully wrapped skin care products to loved ones and friends tailored to their skin needs? Let us do the work." />
                </Helmet>
				<ReferralBody />
			</div>
		);
	}
}

export default withRouter(Referral);



// WEBPACK FOOTER //
// ./src/views/referral/Referral.js